import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGetInboxCountsQuery } from '@/redux/internal-services/notificationsApi';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { openNotificationsPanel, toggleNotificationsPanel } from '@/redux/slices/notificationsPanelSlice';
import { IconButton } from '@/components/UI/IconButton';
import { BellIcon } from '@/components/UI/icons';

const NotificationBell: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const isPanelOpen = useAppSelector((state) => state.notificationsPanel.isOpen);
  const { data: counts } = useGetInboxCountsQuery();
  const unread = counts?.unread ?? 0;

  const handleClick = () => {
    if (location.pathname !== '/chat') {
      dispatch(openNotificationsPanel());
      navigate('/chat');
    } else {
      dispatch(toggleNotificationsPanel());
    }
  };

  return (
    <IconButton
      label={unread > 0 ? `Notifications, ${unread} unread` : 'Notifications'}
      onClick={handleClick}
      aria-pressed={isPanelOpen}
      active={isPanelOpen}
      className="relative"
    >
      <BellIcon size={20} />
      {unread > 0 && (
        // A pill that grows with the count ("99+"), kept inside the button's corner so it can never
        // spill over the neighbouring avatar.
        <span
          aria-hidden="true"
          className="absolute right-0 top-0 flex h-[1.125rem] min-w-[1.125rem] items-center justify-center rounded-full bg-danger-fill px-1 text-micro font-semibold leading-none tracking-normal text-white ring-2 ring-ui-card"
        >
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </IconButton>
  );
};

export default NotificationBell;
